import React, {useRef, useState} from "react";
import {Menubar} from "primereact/menubar";
import {XFormNavigator3} from "@michalrakus/x-react-web-lib/XFormNavigator3";
import {OperationType, XUtils} from "@michalrakus/x-react-web-lib/XUtils";
import {XHolder1, XHolder2} from "@michalrakus/x-react-web-lib/XHolders";
import {MenuItem} from "primereact/menuitem";
import {Utils, XsAccessType} from "./Utils";
import {XEnumEnumBrowse} from "./forms/user/XEnumEnumBrowse";
import {SluzbaDropdown} from "./forms/user/SluzbaDropdown";
import {XUserDePaulBrowse} from "./forms/user/XUserDePaulBrowse";
import {SluzbaBrowse} from "./forms/user/SluzbaBrowse";
import {HromEvidForm} from "./forms/klient/HromEvidForm";
import {Param, Rola, SluzbaEnum} from "./common/enums";
import {MiestoMoznehoKontaktuBrowse} from "./forms/zapisy/MiestoMoznehoKontaktuBrowse";
import {VykazStreetworkBrowse} from "./forms/zapisy/VykazStreetworkBrowse";
import {Sluzba} from "./model/user/sluzba.entity";
import {SluzbaRolaPravaBrowse} from "./forms/user/SluzbaRolaPravaBrowse";
import {ZapisBrowse} from "./forms/zapisy/ZapisBrowse";
import {CenovaKategoriaBrowse} from "./forms/klient/CenovaKategoriaBrowse";
import {ZmluvaBrowse} from "./forms/klient/ZmluvaBrowse";
import {XEnum} from "./model/user/x-enum.entity";
import {UbytovanieBrowse} from "./forms/noclaharen/UbytovanieBrowse";
import {MiestnostBrowse} from "./forms/noclaharen/MiestnostBrowse";
import {IdList, XDateFromToRequest, XYearRequest} from "./common/utils-api";
import {XDateFromToDialog, XDateFromToDialogState} from "./forms/XDateFromToDialog";
import {XUtilsCommon} from "@michalrakus/x-react-web-lib/XUtilsCommon";
import {XYearDialog, XYearDialogState} from "./forms/XYearDialog";
import {ReportKlientiPodlaMiestnostiDialog} from "./forms/noclaharen/ReportKlientiPodlaMiestnostiDialog";
import {XParamNoclaharenBrowse} from "./forms/noclaharen/XParamNoclaharenBrowse";
import {XUserDePaul} from "./model/user/x-user-de-paul.entity";
import {XUserSluzbaRola} from "./model/user/x-user-sluzba-rola.entity";
import {UbytovanieForm} from "./forms/noclaharen/UbytovanieForm";
import {Toast} from "primereact/toast";
import {KlientSluzbaBrowse} from "./forms/klient/KlientSluzbaBrowse";
import {XsGroupByFieldBrowse} from "./forms/statistics/XsGroupByFieldBrowse";
import {XsStatFieldBrowse} from "./forms/statistics/XsStatFieldBrowse";
import {XsTableBrowse} from "./forms/statistics/XsTableBrowse";
import {XsIntervalSetBrowse} from "./forms/statistics/XsIntervalSetBrowse";
import {XrReportBrowse} from "./forms/reports/XrReportBrowse";
import {ZapisForm} from "./forms/zapisy/ZapisForm";
import {StatBrowse} from "./forms/ciselniky/StatBrowse";
import {ObecBrowse} from "./forms/ciselniky/ObecBrowse";
import {KlientBrowse} from "./forms/klient/KlientBrowse";
import {XtDocTemplateBrowse} from "./forms/doc-templates/XtDocTemplateBrowse";

// TODO - v buducnosti presunut do XReactWebLib

// helper structure
interface XRootForm {
    element: any | null,
    // do sluzbaEnumList si zapiseme sluzby, pre ktore je dana polozka menu (a jej obsah) povoleny
    // ak user v dropdowne zmeni sluzbu na nepovolenu, zrusime obsah (element nastavime na null)
    // ak je sluzbaEnumList undefined, tak su povolene vsetky sluzby (napr. ciselnik statov)
    // ak je sluzbaEnumList = Object.values(SluzbaEnum) (vsetky enumy), tak je dany obsah (napr. klienti) povoleny pre vsetky sluzby ale sluzba musi byt zvolena
    sluzbaEnumList?: SluzbaEnum[]
}

export const XMenu = (props: {defaultFormElement?: any; logout: () => void;}) => {

    const [xRootForm, setXRootForm] = useState<XRootForm>({element: props.defaultFormElement});
    const [renderHolder1, setRenderHolder1] = useState<boolean>(true);

    const [xDateFromToDialogState, setXDateFromToDialogState] = useState<XDateFromToDialogState>({opened: false});
    const [xYearDialogState, setXYearDialogState] = useState<XYearDialogState>({opened: false});
    const [reportKlientiPodlaMiestnostiDialogOpened, setReportKlientiPodlaMiestnostiDialogOpened] = useState<boolean>(false);

    const toast = useRef<Toast>(null);
    const xFormNavigator = useRef<XFormNavigator3>(null);

    const mamePozadovanuSluzbu = (sluzbaEnumList: SluzbaEnum[] | undefined): boolean => {
        let mamePozadovanuSluzbu: boolean = false; // default
        if (sluzbaEnumList === undefined) {
            mamePozadovanuSluzbu = true; // obsah nezavisly od sluzby (napr. ciselnik statov)
        }
        else {
            const sluzbaKod: string | undefined = Utils.getCurrentSluzba()?.kod;
            if (sluzbaKod) {
                mamePozadovanuSluzbu = sluzbaEnumList.includes(sluzbaKod as SluzbaEnum);
            }
        }
        return mamePozadovanuSluzbu;
    }

    // helper
    const noclaharenReportDisabled = (): boolean => {
        return !Utils.userMaSluzbuRolu(SluzbaEnum.noclaharen, Rola.veduci, Rola.socialnyPracovnik);
    }
    
    const zistiVisibleDisabled = (sluzbaEnumList: SluzbaEnum[] | undefined, existsChildVisible?: boolean): {visible: boolean, disabled: boolean} => {
        let visible: boolean;
        // ak nemame ziadny child, tak nezobrazime vobec
        if (existsChildVisible === false) {
            visible = false;
        }
        else {
            visible = mamePozadovanuSluzbu(sluzbaEnumList);
        }
        let disabled: boolean = !visible;

        if (Utils.isUserAdmin()) {
            visible = true;
        }

        return {visible, disabled};
    }

    const zistiExistsVisible = (items: MenuItem[]): boolean => {
        return items.some((item: MenuItem) => item.visible);
    }

    // helper
    const createMenuItem = (label: string, formElement: any, sluzbaEnumList: SluzbaEnum[] | undefined): MenuItem => {
        const visibleDisabled: {visible: boolean, disabled: boolean} = zistiVisibleDisabled(sluzbaEnumList);
        return {label: label, command: () => {openForm(formElement, sluzbaEnumList);}, visible: visibleDisabled.visible, disabled: visibleDisabled.disabled};
    }

    // helper
    const createComposedMenuItem = (label: string, items: MenuItem[], sluzbaEnumList: SluzbaEnum[] | undefined): MenuItem => {
        const existsVisible: boolean = zistiExistsVisible(items);
        const visibleDisabled: {visible: boolean, disabled: boolean} = zistiVisibleDisabled(sluzbaEnumList, existsVisible);
        return {label: label, items: items, visible: visibleDisabled.visible, disabled: visibleDisabled.disabled};
    }

    // noclaharen ma vlastne menu, kde ma klientov, osetrenia (zapisy)
    const vsetkySluzbyBezNoclaharne: SluzbaEnum[] = Object.values(SluzbaEnum).filter(sluzbaEnum => sluzbaEnum !== SluzbaEnum.noclaharen);
    const utulky: SluzbaEnum[] = [SluzbaEnum.lujzaPoradenstvo, SluzbaEnum.vincentPoradenstvo];

    const items: MenuItem[] = [
        createMenuItem('Klienti', <KlientSluzbaBrowse/>, Utils.klientiNezdielani() ? vsetkySluzbyBezNoclaharne : undefined),
        createMenuItem('Zmluvy', <ZmluvaBrowse/>, utulky),
        createMenuItem('Pridať zápis opakovane', <ZapisForm onSaveOrCancel={(object: any | null, objectChange: OperationType) => onSaveOrCancelZapisForm(object, objectChange, !renderHolder1)}/>, // !renderHolder1 - po zavolani openForm bude mat renderHolder1 opacnu hodnotu - preto negacia !
            [SluzbaEnum.alzbetaOsetrovna]), // len pre osetrovnu chceme tuto moznost (pre soc poradenstvo si to nezelaju)
        createMenuItem('Zápisy', <ZapisBrowse/>, vsetkySluzbyBezNoclaharne),
        createMenuItem('Denník', <VykazStreetworkBrowse/>, [SluzbaEnum.streetwork]),
        createComposedMenuItem(
            'Hromadná evid.',
            [
                // TODO - ked budu enumy cache-ovane, tak pouzit x-enum
                createMenuItem('Sprchovanie', <HromEvidForm typCinnosti={{id: 61, code: "sprchovanie", name: "sprchovanie"} as XEnum}/>, utulky),
                createMenuItem('Výmena posteľnej bielizne', <HromEvidForm typCinnosti={{id: 62, code: "vymenaPostelnejBielizne", name: "výmena posteľnej bielizne"} as XEnum}/>, utulky),
                createMenuItem('Pranie osobných vecí', <HromEvidForm typCinnosti={{id: 63, code: "pranieOsobnychVeci", name: "pranie osobných vecí"} as XEnum}/>, utulky),
                createMenuItem('Ubytovanie', <HromEvidForm typCinnosti={{id: 64, code: "ubytovanie", name: "ubytovanie"} as XEnum}/>, utulky)
            ],
            utulky
        ),
        createComposedMenuItem(
            'Nocľaháreň',
            [
                createMenuItem('Klienti', <KlientSluzbaBrowse/>, [SluzbaEnum.noclaharen]),
                createMenuItem('Pridať ubytovanie opakovane', <UbytovanieForm onSaveOrCancel={(object: any | null, objectChange: OperationType) => onSaveOrCancelUbytovanieForm(object, objectChange, !renderHolder1)}/>, [SluzbaEnum.noclaharen]), // !renderHolder1 - po zavolani openForm bude mat renderHolder1 opacnu hodnotu - preto negacia !
                createMenuItem('Ubytovania', <UbytovanieBrowse/>, [SluzbaEnum.noclaharen]),
                createMenuItem('Ubytovania dnes', <UbytovanieBrowse dnes={true}/>, [SluzbaEnum.noclaharen]),
                createMenuItem('Pridať ošetrenie opakovane', <ZapisForm onSaveOrCancel={(object: any | null, objectChange: OperationType) => onSaveOrCancelZapisForm(object, objectChange, !renderHolder1)}/>, [SluzbaEnum.noclaharen]), // !renderHolder1 - po zavolani openForm bude mat renderHolder1 opacnu hodnotu - preto negacia !
                createMenuItem('Ošetrenia', <ZapisBrowse/>, [SluzbaEnum.noclaharen]),
                {
                    label:'Reporty',
                    disabled: !(Utils.getCurrentSluzba()?.kod === SluzbaEnum.noclaharen),
                    items: [
                        {label:'Noví klienti', command: () => {openReportObdobieOdDo('novi-klienti');}, disabled: noclaharenReportDisabled()},
                        {label:'Štatistika klientov za rok', command: () => {openReportStatistikaKlientovZaRok();}, disabled: noclaharenReportDisabled()},
                        {label:'Štatistika klientov za obdobie', command: () => {openReportObdobieOdDo('statistika-klientov-za-obdobie');}, disabled: noclaharenReportDisabled()},
                        {label:'Matica klient - deň', command: () => {openReportObdobieOdDo('matica-klient-den');}, disabled: noclaharenReportDisabled()},
                        {label:'Počet klientov za deň', command: () => {openReportObdobieOdDo('pocet-klientov-za-den');}, disabled: noclaharenReportDisabled()},
                        {label:'Platby klientov za deň', command: () => {openReportObdobieOdDo('platby-klientov-za-den');}, disabled: noclaharenReportDisabled()},
                        {label:'Klienti podľa miestnosti', command: () => {openReportKlientiPodlaMiestnosti();}}, // tento report je pristupny aj pracovnikom
                        {label:'Prerušenia služby', command: () => {openReportObdobieOdDo('noclaharen-prerusenia');}} // tento report je pristupny aj pracovnikom
                    ]
                },
                {
                    label:'Administrácia',
                    disabled: !Utils.userMaSluzbuRolu(SluzbaEnum.noclaharen, Rola.veduci),
                    items: [
                        createMenuItem('Miestnosti', <MiestnostBrowse/>, [SluzbaEnum.noclaharen]),
                        createMenuItem('Parametre', <XParamNoclaharenBrowse/>, [SluzbaEnum.noclaharen]),
                        {label:'Vrecia na likvidáciu', command: () => {vreciaNaLikvidaciu();}},
                    ]
                }
            ],
            [SluzbaEnum.noclaharen]
        ),
        createComposedMenuItem(
            'Zoznamy',
            [
                createMenuItem('Cenové kategórie', <CenovaKategoriaBrowse/>, utulky),
                createMenuItem('Miesta možného kontaktu', <MiestoMoznehoKontaktuBrowse/>, [SluzbaEnum.streetwork])
            ],
            undefined
        ),
        {
            label:'Štatistiky',
            visible: Utils.xsUserHasAccess(XsAccessType.runOnly),
            items:[
                {label:'Interval sets', command: () => {openForm(<XsIntervalSetBrowse/>);}, visible: Utils.xsUserHasAccess(XsAccessType.usageOnly)},
                {label:'Group by fields', command: () => {openForm(<XsGroupByFieldBrowse/>);}, visible: Utils.xsUserHasAccess(XsAccessType.usageOnly)},
                {label:'Stat fields', command: () => {openForm(<XsStatFieldBrowse/>);}, visible: Utils.xsUserHasAccess(XsAccessType.usageOnly)},
                {label:'Štatistiky', command: () => {openForm(<XsTableBrowse/>);}},
                {label:'Zoznamy', command: () => {openForm(<XrReportBrowse/>);}}
            ]
        },
        {
            label:'Administrácia',
            visible: Utils.isUserAdmin(),
            items:[
                {label:'Používatelia', command: () => {openForm(<XUserDePaulBrowse/>);}},
                //{label:'Change password', command: () => {openForm(<XChangePasswordForm setXToken={props.setXToken}/>);}}
                {label:'Enums', command: () => {openForm(<XEnumEnumBrowse/>);}},
                {label:'Služby', command: () => {openForm(<SluzbaBrowse/>);}},
                {label:'Práva', command: () => {openForm(<SluzbaRolaPravaBrowse/>);}},
                {label:'Doc templates', command: () => {openForm(<XtDocTemplateBrowse/>);}},
                {label:'Štáty', command: () => {openForm(<StatBrowse/>);}},
                {label:'Obce/mestá', command: () => {openForm(<ObecBrowse/>);}},
                {label:'Klienti - všetky služby', command: () => {openForm(<KlientBrowse label="Klienti - všetky služby"/>);}}
                // docasne na testovanie
                //{label:'Reload', command: () => {XUtils.reload();}},
                //{label:'Reload if new version', command: () => {XUtils.reloadIfNewVersionNow();}}
            ]
        },
        {
            label: 'Odhlásenie',
            icon: 'pi pi-fw pi-power-off',
            command: () => {
                // check if some form is not opened and data are changed or row is locked
                if (!xFormNavigator.current!.cancelFormEdit()) {
                    return; // user stopped canceling
                }
                if (window.confirm("Určite sa chceš odhlásiť?")) {
                    props.logout();
                }
            }
        }
    ];

    const openForm = (newFormElement: any, sluzbaEnumList?: SluzbaEnum[]) => {
        // check if some form is not opened and data are changed or row is locked
        if (!xFormNavigator.current!.cancelFormEdit()) {
            return; // user stopped canceling
        }

        setXRootForm({element: newFormElement, sluzbaEnumList: sluzbaEnumList});
        // we want refresh the whole element tree (call constructors of class components, call componentDidMount methods to refresh data, ...)
        // change of Holder1 to Holder2 and back will cause mounting of new component tree
        // without this, changing from <XBrowse entity="Brand"/> to <XBrowse entity="Car"/> will not work (component tree will not change)
        setRenderHolder1(!renderHolder1);
        // async check for new version
        XUtils.reloadIfNewVersion();
    }

    const onChangeSluzba = (sluzba: Sluzba) => {
        // check if some form is not opened and data are changed or row is locked
        if (!xFormNavigator.current!.cancelFormEdit()) {
            return; // user stopped canceling
        }

        if (xRootForm.element && !mamePozadovanuSluzbu(xRootForm.sluzbaEnumList)) {
            setXRootForm({element: null}); // ziaden form sa nezobrazi (treba ist do menu a nieco zvolit)
        }
        // otvorime browse, ktory mame ulozeny v rootFormElement (posledne otvoreny browse)
        setRenderHolder1(!renderHolder1);
        // async check for new version
        XUtils.reloadIfNewVersion();
    }

    const onSaveOrCancelUbytovanieForm = (object: any | null, objectChange: OperationType, renderHolder1: boolean) => {
        // dame aj pre cancel novy (cisty) formular
        //if (objectChange === OperationType.Insert) {
            // bol save, otvorime formular pre novy insert
            // hodnotu renderHolder1 si odovzdavame cez parameter, lebo ked sme ju citali zo state variable renderHolder1, tak bola vzdy ta ista (ked odovzdavame funkciu, zachovava sa kontext)
            const renderHolder1New: boolean = !renderHolder1;
            setXRootForm({element: <UbytovanieForm onSaveOrCancel={(object: any | null, objectChange: OperationType) => onSaveOrCancelUbytovanieForm(object, objectChange, renderHolder1New)}/>, sluzbaEnumList: xRootForm.sluzbaEnumList});
            setRenderHolder1(renderHolder1New);
            if (objectChange === OperationType.Insert) {
                toast.current?.show({severity: 'info', summary: 'Info', detail: 'Ubytovanie bolo zapísané', life: 3000});
            }
        //}
        //else {
            // bol cancel (malo by platit objectChange === OperationType.None), zobrazime prazdny screen
        //    setRootFormElement(null); // ziaden form sa nezobrazi (treba ist do menu a nieco zvolit)
        //}

        // async check for new version
        XUtils.reloadIfNewVersion();
    }

    const onSaveOrCancelZapisForm = (object: any | null, objectChange: OperationType, renderHolder1: boolean) => {
        // hodnotu renderHolder1 si odovzdavame cez parameter, lebo ked sme ju citali zo state variable renderHolder1, tak bola vzdy ta ista (ked odovzdavame funkciu, zachovava sa kontext)
        const renderHolder1New: boolean = !renderHolder1;
        setXRootForm({element: <ZapisForm onSaveOrCancel={(object: any | null, objectChange: OperationType) => onSaveOrCancelZapisForm(object, objectChange, renderHolder1New)}/>, sluzbaEnumList: xRootForm.sluzbaEnumList});
        setRenderHolder1(renderHolder1New);
        if (objectChange === OperationType.Insert) {
            toast.current?.show({severity: 'info', summary: 'Info', detail: 'Zápis bol zapísaný', life: 3000});
        }

        // async check for new version
        XUtils.reloadIfNewVersion();
    }

    const vreciaNaLikvidaciu = async () => {
        const exspiraciaVriec: number = await Utils.getXParamValueAsInt(Param.n_exspiraciaVriec);
        const datumUvolnitNepouziteOd: Date = XUtilsCommon.dateAddDays(Utils.todayNoclaharen(), -exspiraciaVriec)!;

        let idKlientSluzbaList: IdList;
        try {
            idKlientSluzbaList = await XUtils.fetchOne('vrecia-na-likvidaciu-najdi-klient-sluzba-ids', {datumUvolnitNepouziteOd: datumUvolnitNepouziteOd});
        }
        catch (e) {
            XUtils.showErrorMessage('Nepodarilo sa zistiť id klientov s vrecami na likvidáciu.', e);
            return;
        }

        if (idKlientSluzbaList.idList.length === 0) {
            alert("Nenašli sa žiadne vrecia na likvidáciu.");
        }
        else {
            if (!await XUtils.openExcelReport('vrecia-na-likvidaciu-vytvor-report', idKlientSluzbaList, 'vrecia-na-likvidaciu')) {
                return;
            }

            if (window.confirm("Uvoľniť nájdené čísla vriec?")) {
                try {
                    await XUtils.fetch('vrecia-na-likvidaciu-uvolni', idKlientSluzbaList);
                }
                catch (e) {
                    XUtils.showErrorMessage('Nepodarilo sa uvoľniť nájdené čísla vriec.', e);
                    return;
                }
                alert("Nájdené čísla vriec boli úspešne uvoľnené.");
            }
        }
    }

    const openReportObdobieOdDo = (apiPath: string) => {
        const datumDo: Date = Utils.todayNoclaharen();
        let datumOd: Date = XUtilsCommon.dateAddMonths(datumDo, -1)!;
        datumOd = XUtilsCommon.dateAddDays(datumOd, 1)!;
        setXDateFromToDialogState({
            opened: true,
            dateFrom: datumOd,
            dateTo: datumDo,
            onHideDialog: (ok: boolean, dateFrom: Date | null, dateTo: Date | null) => openReportObdobieOdDoOnHideDialog(ok, dateFrom, dateTo, apiPath)
        });
    }

    const openReportObdobieOdDoOnHideDialog = (ok: boolean, dateFrom: Date | null, dateTo: Date | null, apiPath: string) => {
        if (ok) {
            const xDateFromToRequest: XDateFromToRequest = {dateFrom: dateFrom, dateTo: dateTo};
            XUtils.openExcelReport(apiPath, xDateFromToRequest);
        }
        setXDateFromToDialogState({opened: false});
    }

    const openReportStatistikaKlientovZaRok = () => {
        const year: number = Utils.todayNoclaharen().getFullYear();
        setXYearDialogState({
            opened: true,
            yearFrom: 2014, // najnizsi datum v tabulke ubytovanie je v roku 2014
            yearTo: year,
            yearInit: year,
            onHideDialog: openReportStatistikaKlientovZaRokOnHideDialog
        });
    }

    const openReportStatistikaKlientovZaRokOnHideDialog = (ok: boolean, year: number | undefined) => {
        if (ok) {
            const xYearRequest: XYearRequest = {year: year!};
            XUtils.openExcelReport('statistika-klientov-za-rok', xYearRequest);
        }
        setXYearDialogState({opened: false});
    }

    const openReportKlientiPodlaMiestnosti = () => {
        setReportKlientiPodlaMiestnostiDialogOpened(true);
    }

    const zistiRole = (): string => {
        let role: string = "";
        const user: XUserDePaul = Utils.getXUserDePaul();
        if (user.admin) {
            role = "Admin";
        }
        const currentSluzba: Sluzba | undefined = Utils.getCurrentSluzba();
        if (currentSluzba) {
            // mame vybratu sluzbu v comboboxe v menu
            const sluzbaRolaList: XUserSluzbaRola[] = user.xUserSluzbaRolaList.filter((xUserSluzbaRola: XUserSluzbaRola) => xUserSluzbaRola.sluzbaRola.sluzba.id === currentSluzba.id);
            const rolaList: string[] = sluzbaRolaList.map((xUserSluzbaRola: XUserSluzbaRola) => xUserSluzbaRola.sluzbaRola.rola.name);
            if (rolaList.length > 0) {
                const roleStr: string = rolaList.join(', ');
                if (role !== "") {
                    role += ", ";
                }
                role += roleStr;
            }
            if (role === "") {
                role = "žiadna"; // pre danu sluzbu nema priradenu ziadnu rolu (asi ani nemoze nastat)
            }
        }
        return role;
    }

    const backendUrl: string = XUtils.getXBackendUrl();
    const testEnv: boolean = backendUrl.indexOf('test') !== -1; // ak mame app-test.depaul.sk

    /* dropdown ide nalavo, backend + user ide napravo (pomocou marginLeft: 'auto') - este boli potrebne zmeny v App.css */
    const end: any = (
        <div className="flex" style={{width: '100%'}}>
            <div className={!XUtils.isMobile() ? "m-3": "m-1"}/>
            <SluzbaDropdown onChangeSluzba={onChangeSluzba}/>
            <div className="flex align-content-center" style={{marginLeft: 'auto', maxHeight: '2.7rem', overflowY: 'auto'}}>
                {testEnv ? <div style={{padding: '0.5rem', fontWeight: 'bold'}}>TEST</div> : null}
                {/* <div style={{padding: '0.5rem'}}>Backend: {XUtils.getXBackendUrl()}</div> */}
                {!XUtils.isMobile() ?
                    [<div style={{padding: '0.5rem'}}>Používateľ: {/*XUtils.getUsername()*/XUtils.getXToken()?.xUser?.name}</div>,
                    <div style={{padding: '0.5rem'}}>Rola: {zistiRole()}</div>]
                    : <div>{XUtils.getXToken()?.xUser?.name}<br/>{zistiRole()}</div>}
            </div>
        </div>
    );

    // little workaround - see remark in function openForm
    let holderWithNavigator;
    if (renderHolder1) {
        holderWithNavigator = <XHolder1 element={<XFormNavigator3 ref={xFormNavigator} rootFormElement={xRootForm.element}/>}/>;
    }
    else {
        holderWithNavigator = <XHolder2 element={<XFormNavigator3 ref={xFormNavigator} rootFormElement={xRootForm.element}/>}/>;
    }

    return (
        <div>
            <Toast ref={toast} position="top-center"/>
            <Menubar id="menuId" model={items} end={end} className="mb-1" pt={testEnv ? {root: {style: {backgroundColor: 'lightskyblue'}}} : undefined}/>
            {holderWithNavigator}
            <XDateFromToDialog dialogState={xDateFromToDialogState}/>
            <XYearDialog dialogState={xYearDialogState}/>
            <ReportKlientiPodlaMiestnostiDialog dialogOpened={reportKlientiPodlaMiestnostiDialogOpened} onHideDialog={() => setReportKlientiPodlaMiestnostiDialogOpened(false)}/>
        </div>
    );
}
